import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from 'src/app/core/core.module';
import { SisMapReferenceAdapter } from 'src/app/sismap-reference/domain/sismap-reference.adapter';
import { SisMapReferencePage } from 'src/app/sismap-reference/sismap-reference.page';
import { SisMapReferenceService } from 'src/app/sismap-reference/sismap-reference.service';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: SisMapReferencePage,
      },
    ]),
    FormsModule,
    CoreModule,
    MatTooltipModule,
    TranslateModule,
  ],
  declarations: [
    SisMapReferencePage
  ],
  providers: [
    SisMapReferenceService,
    SisMapReferenceAdapter
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SisMapReferencePageModule { }
